/**
 * The copyright and version line every page ends with.
 *
 * `__CONSOLE_VERSION__` is stamped at build time from CHANGELOG.md
 * (`scripts/console-version.mjs`), the same heading the release workflow tags,
 * so the footer names the version the build was released as. The year is read
 * at render time so the notice never goes stale between releases.
 *
 * `data-console-version` is what the visual baselines normalise: a release
 * changes this text and nothing else about a page.
 *
 * The legal links are console paths, so a bundle served from anywhere else —
 * the provider panel on a provider's own host — passes `links={false}` rather
 * than link to a page its origin does not have.
 */
export const CONSOLE_VERSION: string = __CONSOLE_VERSION__

export function LegalFooter({ className = '', links = true }: { className?: string; links?: boolean }) {
  return (
    <small className={`legal-footer ${className}`.trim()}>
      <span>© {new Date().getFullYear()} DDWS. All rights reserved.</span>
      {links && <>
        <a className="legal-footer-link" href="/app/legal/privacy">Privacy Policy</a>
        <a className="legal-footer-link" href="/app/legal/terms">Terms of Service</a>
      </>}
      <span className="legal-footer-version" data-console-version="">{CONSOLE_VERSION}</span>
    </small>
  )
}
